import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import Navbar from '../Components/Navbar';
import HeroSection from '../Components/Home';
import PricingSection from '../Components/Pricing';
import AboutSection from '../Components/About';
import TeamMembers from '../Components/TeamMembers';
import Footer from '../Components/footer';
import ResearchSection from '../Components/Research';

const HomePage = () => {
  const [isPricingOpen, setIsPricingOpen] = useState(false);
  const heroRef = useRef(null);
  const researchRef = useRef(null);
  const aboutRef = useRef(null);
  const teamRef = useRef(null);

  const togglePricing = () => setIsPricingOpen((prev) => !prev);

  const scrollToSection = (sectionRef) => {
    if (sectionRef?.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <HomePageContainer>
      <Navbar
        scrollToSection={scrollToSection}
        refs={{ heroRef, researchRef, aboutRef, teamRef }}
        onPricingToggle={togglePricing}
      />

      <Section ref={heroRef}>
        <HeroSection />
      </Section>

      <Section ref={researchRef}>
        <ResearchSection />
      </Section>

      <Section ref={aboutRef}>
        <AboutSection />
      </Section>

      <Section ref={teamRef}>
        <TeamMembers />
      </Section>

      <Section>
        <Footer />
      </Section>

      <PricingSection
        isOpen={isPricingOpen}
        onToggle={togglePricing}
        hideStandalone
      />
    </HomePageContainer>
  );
};

export default HomePage;

const HomePageContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  font-family: 'Poppins', sans-serif;

  /* Background that makes glass blur visible */
  background:
    radial-gradient(900px 700px at 10% 20%, rgba(255, 120, 60, 0.10), transparent 60%),
    radial-gradient(900px 700px at 90% 70%, rgba(0, 170, 255, 0.08), transparent 60%),
    linear-gradient(180deg, #ffffff 0%, #fbfbfb 55%, #ffffff 100%);

  position: relative;
`;

const Section = styled.div`
  width: 100%;

  /* Prevent scrollIntoView from hiding content under fixed navbar */
  scroll-margin-top: 110px;
`;
